import styles from "./Terms.module.css"
import { useState } from 'react';
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import Footer from "../../components/Footer/Footer";
import SubmitButton from "../../components/Button/SubmitButton/SubmitButton";
import TermsPopup from "./components/LosePricePopup/Popup";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";
import { CancelationRow } from "../../types/terms";
/**
* Terms page
* Contains terms of service and a lose compensation price modal
* @returns TSX.Element
*/
const Terms = () => {
    const { t } = useTranslation(); // Translation
    const [termsVisible, setTermsVisible] = useState<boolean>(false) // Lose compensation price modal visibility flag
    // Lost price table header and rows
    const headers = t('terms.cancelation.table.headers', { returnObjects: true }) as string[];
    const rows = t('terms.cancelation.table.rows', { returnObjects: true }) as CancelationRow[];
    return(
        <>
        <div className={styles.Page}>
            <div className={styles.Header}>
                <div className={styles.Headergroup}>
                    <Navbar/>
                </div>
            </div>
                <div className={styles.Content}>
                    <TermsPopup 
                    display={termsVisible} 
                    onClose={()=>setTermsVisible(false)}
                    />
                    <div className={styles.Content}>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.contacts.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey="terms.contacts.text" components={{ 4: <br /> }} />
                            </p>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.basic.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey="terms.basic.text" components={{ 4: <br/> }} />
                            </p>
                        </div>
                        <div className={styles.SplitBlock}>
                            <div className={styles.InfoBlock}>
                                <p className={styles.InfoBlockTitle}>{t("terms.billing.title")}</p>
                                <p className={styles.InfoBlockText}>
                                    <Trans i18nKey="terms.billing.text" components={{ 4: <br/> }} />
                                </p>
                            </div>
                            <div className={styles.InfoBlock}>
                                <p className={styles.InfoBlockTitle}>{t("terms.extra.title")}</p>
                                <p className={styles.InfoBlockText}>
                                    <Trans i18nKey="terms.extra.text" components={{ 4: <br/> }} />
                                </p>
                            </div>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.inventory.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey={t("terms.inventory.text")} components={{ 4: <br/> }} />
                            </p>
                            <div className={styles.ButtonCenter}>
                                <SubmitButton text={t("buttons.lost_pricing")} colorVariant="primary" onClick={()=>setTermsVisible(true)}/>
                            </div>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.min_order.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey={t("terms.min_order.text")} components={{ 4: <br/> }} />
                            </p>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.cancelation.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey={t("terms.cancelation.text")} components={{ 4: <br/> }} />
                            </p>
                            <div className={styles.BaseTable}>
                                <div className={`${styles.BaseTableRow} ${styles.HeaderRow}`}>
                                    {headers.map((header, index)=>(
                                        <div className={styles.BaseTableCell} key={index}><p>{header}</p></div>
                                    ))}
                                </div>
                                {rows.map((row, index) => (
                                <div key={index} className={styles.BaseTableRow}>
                                    <div className={styles.BaseTableCell}>{row.orderValue}</div>
                                    <div className={styles.BaseTableCell}>{row.zeroPercent}</div>
                                    <div className={styles.BaseTableCell}>{row.fiftyPercent}</div>
                                    <div className={styles.BaseTableCell}>{row.hundredPercent}</div>
                                </div>
                                ))}
                            </div>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.price.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey={t("terms.price.text")} components={{ 4: <br/> }} />
                            </p>
                        </div>
                        <div className={styles.InfoBlock}>
                            <p className={styles.InfoBlockTitle}>{t("terms.gdpr.title")}</p>
                            <p className={styles.InfoBlockText}>
                                <Trans i18nKey={t("terms.gdpr.text")} components={{ 4: <br/>, 1: <span/> }} />
                            </p>
                        </div>
                        <p className={styles.BottomText}>{t("terms.from")}</p>
                    </div>            
            </div>
            <div className={styles.Footer}>
                <Footer/>
            </div>
        </div>
        </>
    )
};

export default Terms;
